
import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import SocialProof from './components/SocialProof';
import QualityAndValue from './components/QualityAndValue';
import Installation from './components/Installation';
import WhatsAppCTA from './components/WhatsAppCTA';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Benefits />
      <SocialProof />
      <QualityAndValue />
      <Installation />
      <WhatsAppCTA />
      <Footer />
    </div>
  );
}
